"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var SliderItem_1 = __importDefault(require("shared/components/Slider/SliderItem"));
var OffsetSlider_1 = __importDefault(require("../../shared/components/Slider/OffsetSlider"));
var Tool_1 = __importDefault(require("./Tool"));
var PREFIX = 'OtherTools';
var classes = {
    otherToolsHeader: "".concat(PREFIX, "-otherToolsHeader"),
    toolItem: "".concat(PREFIX, "-toolItem"),
    toolWrapper: "".concat(PREFIX, "-toolWrapper"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, material_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.otherToolsHeader)] = {
            marginTop: theme.spacing(2, 0),
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
            fontSize: 20,
        },
        _b[".".concat(classes.toolItem)] = {
            height: '100%',
            width: 270,
            overflow: 'visible',
            '&.MuiTab-root:last-child, &.MuiTab-root:first-child': {
                margin: 0,
            },
            ':hover': {
                textShadow: 'none',
            },
        },
        _b);
});
var OtherTools = function (_a) {
    var otherTools = _a.otherTools, currentService = _a.currentService;
    if (!(otherTools === null || otherTools === void 0 ? void 0 : otherTools.length)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3, className: classes.otherToolsHeader }, { children: ["Other tools like ", currentService === null || currentService === void 0 ? void 0 : currentService.name] })), (0, jsx_runtime_1.jsx)(OffsetSlider_1.default, __assign({ value: 0, offsetLeft: 42 }, { children: otherTools === null || otherTools === void 0 ? void 0 : otherTools.slice(0, 5).map(function (tool) { return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ p: 3 }, { children: (0, jsx_runtime_1.jsx)(SliderItem_1.default, __assign({ component: "div", className: classes.toolItem }, { children: (0, jsx_runtime_1.jsx)(Tool_1.default, { service: tool }) })) }), tool.id)); }) }))] }));
};
exports.default = OtherTools;
